import globalEventBus from 'toxilibs/event_bus_queued.js'
import playCode from '../play_code.js'

let eventBus = globalEventBus('determine the way')


let way

eventBus.on('player moved', function (cell, beforeToricCoords) {
    way.push({
        cell,
        beforeToricCoords,
        line: lastExecutedLine
    })
})


eventBus.on('player collided', function (targetCoords, direction) {
    way.push({
        collidedWith: targetCoords,
        direction,
        line: lastExecutedLine
    })
})


let lastExecutedLine
eventBus.on('line executed', function (lineNumber) {
    lastExecutedLine = lineNumber
})


let world
eventBus.on('world loaded', function (_world) {
    world = _world
    resetWay(world.player.cell)
})


eventBus.on('player updated by God', resetWay)


eventBus.on('new instructions added', function (rightWayFunction) {
    extendTheWay(rightWayFunction, world.api)
})




function resetWay (cell) {
    way = [{
        cell
    }]
}


function extendTheWay (rightWayFunction, api) {

    playCode({
        wayFunction: rightWayFunction,
        api,
        onLineExecuted: eventBus.emitter('line executed')
    })

    eventBus.emit('way updated', way)

}



